import { EarthBoxIcon } from './EarthBoxIcon';

/**
 * author: GreenTurtwig
 * id 3F4C3330-49D5-4F2B-8FCC-A3448BEF521E
 * name earth-box
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-box.svg
 * tags
 * - Navigation 
 */
export const GlobeBoxIcon = EarthBoxIcon;
export default GlobeBoxIcon